const validate = (values) => {
    const errors = {};
  
    if (!values.type || values.type.trim() === '') {
      errors.type = 'Please enter note type';
    }
    // if (!values.Description) {
    //   errors.Description = 'Please enter Description';
    // }
    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/Masters/components/note-master/validate.js